import {IRootStore} from "../rootStore";
import {
  IVillagesDomainStore,
  VillagesDomainStore
} from "./pages/villagesDomainStore";
import {
  INoticesDomainStore,
  NoticesDomainStore
} from "./pages/noticesDomainStore";
import {EventsDomainStore, IEventsDomainStore} from "./pages/eventsDomainStore";
import {
  IResidentAdminDomainStore,
  ResidentAdminDomainStore
} from "./pages/residentAdminDomainStore";
import EventCatalogueDomainStore, {
  IEventCatalogueDomainStore
} from "./pages/eventCatalogueDomainStore";
import {
  IPrintableCalendarDomainStore,
  PrintableCalendarDomainStore
} from "./pages/printableCalendarDomainStore";
import {
  ITransactionsDomainStore,
  TransactionsDomainStore
} from "./pages/transactionsDomainStore";
import {
  IOccasionDomainStore,
  OccasionDomainStore
} from "./pages/occasionDomainStore";
import {
  IMetricsDomainStore,
  MetricsDomainStore
} from "./pages/metricsDomainStore";
import {
  IVillageCalendarsDomainStore,
  VillageCalendarsDomainStore
} from "./pages/villageCalendarsDomainStore";
import {
  IPersonTypesDomainStore,
  PersonTypesDomainStore
} from "./pages/personTypesDomainStore";
import {
  IResidentActionRequiredCountsDomainStore,
  ResidentActionRequiredCountsDomainStore
} from "./pages/residentActionRequiredCountsDomainStore";
import {DepartmentTypeCode} from "../../shared/enums/departmentTypeCode";

export interface IDomainStore {
  rootStore: IRootStore;
  villagesDomainStore: IVillagesDomainStore;
  noticesDomainStore: INoticesDomainStore;
  independentResidentAdminDomainStore: IResidentAdminDomainStore;
  servicedApartmentResidentAdminDomainStore: IResidentAdminDomainStore;
  residentActionRequiredCountsDomainStore: IResidentActionRequiredCountsDomainStore;
  // Owned by the event booking flow so its resident searches never mutate the admin pages' lists.
  eventBookingResidentsDomainStore: IResidentAdminDomainStore;
  eventsDomainStore: IEventsDomainStore;
  eventCatalogueDomainStore: IEventCatalogueDomainStore;
  printableCalendarDomainStore: IPrintableCalendarDomainStore;
  transactionsDomainStore: ITransactionsDomainStore;
  occasionDomainStore: IOccasionDomainStore;
  metricsDomainStore: IMetricsDomainStore;
  villageCalendarsDomainStore: IVillageCalendarsDomainStore;
  personTypesDomainStore: IPersonTypesDomainStore;
}

export class DomainStore implements IDomainStore {
  rootStore: IRootStore;
  villagesDomainStore: IVillagesDomainStore;
  noticesDomainStore: INoticesDomainStore;
  independentResidentAdminDomainStore: IResidentAdminDomainStore;
  servicedApartmentResidentAdminDomainStore: IResidentAdminDomainStore;
  residentActionRequiredCountsDomainStore: IResidentActionRequiredCountsDomainStore;
  eventBookingResidentsDomainStore: IResidentAdminDomainStore;
  eventsDomainStore: IEventsDomainStore;
  eventCatalogueDomainStore: IEventCatalogueDomainStore;
  printableCalendarDomainStore: IPrintableCalendarDomainStore;
  transactionsDomainStore: ITransactionsDomainStore;
  occasionDomainStore: IOccasionDomainStore;
  metricsDomainStore: IMetricsDomainStore;
  villageCalendarsDomainStore: IVillageCalendarsDomainStore;
  personTypesDomainStore: IPersonTypesDomainStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
    this.villagesDomainStore = new VillagesDomainStore(
      rootStore.transportServices.villageService
    );
    this.noticesDomainStore = new NoticesDomainStore(
      rootStore.transportServices.noticeService,
      rootStore.userService,
      rootStore.transportServices.fileService
    );
    this.residentActionRequiredCountsDomainStore =
      new ResidentActionRequiredCountsDomainStore(
        rootStore.transportServices.residentAdminService
      );
    this.independentResidentAdminDomainStore = new ResidentAdminDomainStore(
      rootStore.transportServices.residentAdminService,
      rootStore.userService,
      DepartmentTypeCode.Independent,
      this.residentActionRequiredCountsDomainStore
    );
    this.servicedApartmentResidentAdminDomainStore =
      new ResidentAdminDomainStore(
        rootStore.transportServices.residentAdminService,
        rootStore.userService,
        DepartmentTypeCode.Serviced,
        this.residentActionRequiredCountsDomainStore
      );
    // Department scope is resolved per-search from the selected calendar's audience.
    this.eventBookingResidentsDomainStore = new ResidentAdminDomainStore(
      rootStore.transportServices.residentAdminService,
      rootStore.userService,
      DepartmentTypeCode.Independent
    );
    this.villageCalendarsDomainStore = new VillageCalendarsDomainStore(
      rootStore.transportServices.villageCalendarService
    );
    this.eventsDomainStore = new EventsDomainStore(
      rootStore.transportServices.eventService,
      rootStore.transportServices.fileService,
      rootStore.userService,
      rootStore.transportServices.villageScheduleService,
      this.villageCalendarsDomainStore
    );

    this.eventCatalogueDomainStore = new EventCatalogueDomainStore(
      rootStore.transportServices.eventCatalogueService,
      rootStore.transportServices.fileService,
      rootStore.transportServices.eventService,
      rootStore.userService
    );
    this.printableCalendarDomainStore = new PrintableCalendarDomainStore(
      rootStore.transportServices.printableCalendarService
    );
    this.transactionsDomainStore = new TransactionsDomainStore(
      rootStore.transportServices.processedBookingService,
      rootStore.userService
    );
    this.occasionDomainStore = new OccasionDomainStore(
      rootStore.transportServices.occasionService
    );
    this.metricsDomainStore = new MetricsDomainStore(
      rootStore.transportServices.eventService,
      rootStore.transportServices.noticeService,
      this.villageCalendarsDomainStore
    );
    this.personTypesDomainStore = new PersonTypesDomainStore(
      rootStore.transportServices.personTypeService
    );
  }
}
